import {Component, computed, input} from '@angular/core';
import {CurrencyPipe} from '@angular/common';

export interface DayTripPaymentRow {
  travellerName: string;
  portion: number;
  dayTripAmount: number;
  // Portion less day trips, less any pre-payment already made (never below 0).
  finalisationAmount: number;
  prepaymentAmount?: number; // The TA's pre-payment; prepaid (single-traveller) TAs only.
}

/**
 * Per-traveller split of the acquitted value: Finance pays the finalisation amount, Compliance pays
 * the day trip amount. 'prepayment' mode splits the approved value into prepayment and day trips instead.
 */
@Component({
  selector: 'manage-ta-day-trip-payment-table',
  imports: [
    CurrencyPipe,
  ],
  templateUrl: './manage-ta-day-trip-payment-table.html',
})
export class ManageTaDayTripPaymentTable {
  rows = input.required<DayTripPaymentRow[]>();
  mode = input<'dayTrip' | 'prepayment'>('dayTrip');
  showPrepayment = computed(() => this.rows().some(row => row.prepaymentAmount != null));
  showFinalisation = computed(() => this.mode() === 'dayTrip');
  // Prepayment mode drops the day trip column when there are none.
  showDayTrip = computed(() => this.mode() === 'dayTrip' || this.rows().some(row => row.dayTripAmount > 0));
  columnCount = computed(() =>
    2 + [this.showPrepayment(), this.showFinalisation(), this.showDayTrip()].filter(Boolean).length);
}
